import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AppService } from 'src/app/app.service';
import { AuthService } from 'src/app/services/auth.service';
import { RentingService } from 'src/app/services/renting.service';
import { VerifResponsiveService } from 'src/app/services/verif-responsive.service';


@Component({
  selector: 'app-location-insurance-value',
  templateUrl: './location-insurance-value.component.html',
  styleUrls: ['./location-insurance-value.component.scss']
})
export class LocationInsuranceValueComponent implements OnInit, OnDestroy {

  rentingSubscription: Subscription;

  valueGetted: boolean = false;
  sumPrimeJournaliere: number;
  primeJournaliereGalsen: number;

  public lazyLoad: boolean = false;
  public viewType: string = "list";
  public column: number = 4;
  public p: number = 1;
  public rentings:any[]=[];

  displayedColumns: string[] = ['period_renting', 'amount', 'vehicle', 'status', 'insurance', 'logder', 'owner', 'date'];

  dataSource!: MatTableDataSource<any>;
  @ViewChild(MatPaginator, {static: true}) paginator!: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort!: MatSort;

  public currency: string;

  constructor(private router: Router, private authService: AuthService, 
              private rentingService: RentingService, 
              private appService: AppService,
              private verifResponsiveService:VerifResponsiveService
            ) { }

  ngOnInit(): void {

    this.verifResponsiveService.confirmResponsive().subscribe((data) => {
      this.viewType = data ? 'grid' : 'list';
    });
    
    this.currency = this.appService.getCurrency();
    
    let res = this.authService.getUserOfLocalStorage();

    if(res.status) {

      const storage = localStorage.getItem("user");

      this.getRenting();

    } else {

      this.router.navigate(["/login"]);

    }

  }

  getRenting() {

    this.rentingSubscription = this.rentingService.valueInsuranceAccordingRenting().subscribe((res: any) => {

      // console.log(res);
      this.rentings = res.rentings;
      this.dataSource = new MatTableDataSource(res.rentings);

      this.dataSource.paginator = this.paginator;

      this.dataSource.sort = this.sort; 

      this.sumPrimeJournaliere = res.sumPrimeJournaliere;
      this.primeJournaliereGalsen = res.primeJournaliereGalsen;

      this.valueGetted = true;

    });

  }

  ngOnDestroy(): void {
    
    if(this.valueGetted) {

      this.rentingSubscription.unsubscribe();

    }

  }

  refresh() {
    this.getRenting(); 
  }
   
  changeViewType(viewType:string)
  {
    this.viewType = viewType;
  }

}
